import React from 'react';
import { Panel } from 'rsuite';
import { CustomHTML } from './CustomHTML';

const RequirementsList = ({ requirements }) => {
  return (
    <ol
      style={{
        listStylePosition: 'outside',
        paddingLeft: '1.5rem',
        fontWeight: 'bold',
      }}
    >
      {requirements &&
        requirements.map((requirement, index) => {
          let topMargin = index === 0 ? '' : 'mt-24';
          return (
            <li key={`content_section_${index}`}>
              <Panel
                className={`mb-4 ${topMargin}`}
                bodyFill
                style={{ fontWeight: 'normal' }}
              >
                <div style={{ marginBottom: '0.5rem', fontWeight: 'bold' }}>
                  <CustomHTML text={requirement.title} />
                </div>
                <CustomHTML text={requirement.text} />
              </Panel>
            </li>
          );
        })}
    </ol>
  );
};

export default RequirementsList;
